import React, { useState } from 'react'

import logo from '../assets/img/logo.png'
import '../css/Navbar.css'

export default function Navbar() {
  const [info_dropdown_on, set_info_dropdown] = useState(false)
  const [help_dropdown_on, set_help_dropdown] = useState(false)
  const [portrait_nav_on, set_portrait_nav] = useState(false)

  const toggle_info_dropdown = () => {
    set_help_dropdown(false)
    set_info_dropdown(!info_dropdown_on)
  }

  const toggle_help_dropdown = () => {
    set_info_dropdown(false)
    set_help_dropdown(!help_dropdown_on)
  }

  const info_dropdown = info_dropdown_on
                      ? <div id="info-dropdown" className="dropdown-content">
                          <a href="/news">News & Updates</a>
                          <a href="/gallery">Gallery</a>
                          <a href="/contact">Contact Us</a>
                        </div>
                      : null

  const help_dropdown = help_dropdown_on
                      ? <div id="help-dropdown" className="dropdown-content">
                          <a href="/register">Register</a>
                          <a href="/sponsor">Sponsor a child</a>
                          <a href="/donate">Donate</a>
                        </div>
                      : null

  const portrait_nav = portrait_nav_on
                     ? <div id="portrait-nav">
                         <a href="/">Home</a>
                         <a href="/team">Team</a>
                         <a href="/projects">Projects</a>

                         <p>Information</p>
                         <a href="/news">News & Updates</a>
                         <a href="/gallery">Gallery</a>
                         <a href="/contact">Contact Us</a>

                         <p>Help</p>
                         <a href="/register">Register</a>
                         <a href="/sponsor">Sponsor a child</a>
                         <a href="/donate">Donate</a>
                       </div>
                     : null

  return (
    <nav id="main-nav">
      <a id="logo" href="/">
        <img src={logo} alt="main icon" />
      </a>

      <a href="/">
        <button>Home</button>
      </a>

      <a href="/team">
        <button>Team</button>
      </a>

      <a href="/projects">
        <button>Projects</button>
      </a>

      <div>
        <button className="dropdown-btn"
                onClick={ toggle_info_dropdown }
                >
          Information

          <svg viewBox="4 4 896 896" fill="currentColor" aria-hidden="true"><path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path></svg>
        </button>

        { info_dropdown }
      </div>

      {/* <a href="/register">
        <button>Register</button>
      </a>
      <a href="/sponsor">
        <button>Sponsor a child</button>
      </a>
      <a href="/donate">
        <button>Donate</button>
      </a> */}

      <div>
        <button className="dropdown-btn"
                onClick={ toggle_help_dropdown }
                >
          Help

          <svg viewBox="4 4 896 896" fill="currentColor" aria-hidden="true"><path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path></svg>
        </button>

        { help_dropdown }
      </div>

      <svg id="unordered-list-icon"
           onClick={ () => set_portrait_nav(!portrait_nav_on) }
           viewBox="64 64 896 896"
           aria-hidden="true">
        <path d="M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"></path>
      </svg>

      { portrait_nav }
    </nav>
  )
}